<template>
    <div>
        <page-title>{{ $t('menu.tablets.auto_login') }}</page-title>
        <auto-login-table></auto-login-table>
    </div>
</template>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import AutoLoginTable from '@/components/pages/tablets/AutoLoginTable'

export default {
    components: {
        PageTitle,
        AutoLoginTable,
    },
}
</script>
